"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
global.Promise = require('es6-promise').Promise;
require("picturefill");
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var linker_1 = __importDefault(require("linker"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("@fancyapps/fancybox");
var page2top_1 = __importDefault(require("page2top"));
var nav_current_1 = __importDefault(require("nav-current"));
var balloon_1 = __importDefault(require("balloon"));
var object_fit_images_1 = __importDefault(require("object-fit-images"));
var tab_1 = __importDefault(require("tab"));
var scroll_action_1 = __importDefault(require("scroll-action"));
var top_1 = require("top");
var senior_1 = require("senior");
require("expander");
(0, hasher_1.default)();
$(function () {
    new page2top_1.default();
    new linker_1.default({
        extendLink: '.sw-ExtendLink'
    });
    new nav_current_1.default('.st-Global', {
        currentClass: '-current'
    });
    new balloon_1.default();
    (0, tel_handler_1.default)();
    (0, slide_scroll_1.default)({
        easing: 'easeOutExpo',
        speed: 700,
        not: '.sw-NotScroll, .st-Global_Link.-balloon, .sw-Modal'
    });
    $('.sw-Modal').fancybox({
        animationDuration: 700,
        transitionDuration: 700,
        arrows: true,
        infobar: false,
        smallBtn: true,
        toolbar: false,
        // buttons: ['close'],
        idleTime: 999999,
        wheel: false,
        touch: true
    });
    $('#MenuBtn').on('click', function () {
        $('#Menu').toggleClass('-expanded');
    });
    // $('.c-Tab').tab();
    (0, object_fit_images_1.default)('img.sw-ObjectFit', { watchMQ: true });
    new scroll_action_1.default();
    new top_1.Header();
    new top_1.Hero();
    new top_1.Message();
    new top_1.Pickup();
    new top_1.Card();
    new senior_1.Sort();
    new senior_1.Details();
    new senior_1.Nav();
    new tab_1.default({
        elem: '.c-Tab'
    });
    $('.qa-List').expander({
        head: '.qa-List_Head',
        body: '.qa-List_Body'
    });
    $('.vo-qa-List').not('.vo-qa-List.-no').expander({
        head: '.vo-qa-List_Head',
        body: '.vo-qa-List_Body'
    });
    $('.vo-Accordion').expander({
        head: '.vo-Header_Btn',
        body: '.vo-Body'
    });
    //
    $('.c-Gallery_Slider').slick({
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        // variableWidth: true
    });
});
